import { SPLASH_WORDMARK_ATTR } from './splashTokens';
import { beginLogoJourney } from './logoJourney';
import { raiseSignInCover } from './signInCover';

/**
 * Forced MFA gate exit (RD-SEC-021d / KAN-657): "Ir al inicio" keeps ONE
 * continuous CrewVex wordmark into splash → welcome (or splash → dashboard).
 *
 * Same leg-1 as Login's LogoMorphToSplash: fly gate wordmark → splash centre,
 * raise the sign-in cover so the splash stays up while the gate clears and
 * the app mounts. Leave handoff then does leg 2 (welcome glide) or fades
 * with the splash.
 *
 * Call BEFORE onEnrollmentComplete so the morph measures the still-mounted
 * gate wordmark. Returns true when a journey started.
 */
export function startMfaExitLogoHandoff({ reduced = false } = {}) {
  if (typeof document === 'undefined') return false;
  const anchor = document.querySelector('[data-testid="mfa-gate-wordmark"]');
  const rest = document.querySelector(`[${SPLASH_WORDMARK_ATTR}]`);
  if (!anchor || !rest) {
    // Still raise the cover so the gate → app paint isn't a blank flash.
    raiseSignInCover();
    return false;
  }
  try { anchor.style.visibility = 'hidden'; } catch (_e) { /* best-effort */ }
  const started = beginLogoJourney(anchor, rest, { reduced });
  raiseSignInCover();
  return started;
}

export default startMfaExitLogoHandoff;
